import store from '@/store/store';
import { parseBoolean, parseString } from '@/utils/sanitaze.utils';
import { consoleError } from '@/utils/console.utils';
import { hasProp } from '@/utils/validate.utils';
import { CONNECT } from '@/app.config';

/**
 * @typedef {Object} User
 * @property {String} name - Nombre del usuario
 * @property {String} lastName - Apellidos del usuario
 * @property {String} email - Email del usuario
 * @property {Boolean} commercial - El usuario acepta recibir email comerciales
 * @property {Boolean} support - El usuario acepta recibir email de soporte
 * @property {String} language - El idioma configurado por el usuario
 */

/**
 * Da formato a los datos de un usuario
 *
 * @param {Object} userData - Datos de un usuario del backend
 * @return {User} - Datos formateados de una instalación
 */
const sanitizeUser = userData => {
  try {
    const user = {};

    if (hasProp(userData.data, 'name')) {
      user.name = parseString(userData.data.name);
    }
    if (hasProp(userData.data, 'lastName')) {
      user.lastName = parseString(userData.data.lastName);
    }
    if (hasProp(userData.data, 'email')) {
      user.email = parseString(userData.data.email);
    }
    if (hasProp(userData.data, 'commercial')) {
      user.commercial = parseBoolean(userData.data.commercial);
    }
    if (hasProp(userData.data, 'support')) {
      user.support = parseBoolean(userData.data.support);
    }
    if (hasProp(userData.scope[CONNECT.SCOPE], 'language')) {
      const language = parseString(userData.scope[CONNECT.SCOPE].language);
      // TODO: Comprobar que el idioma está dentro de los permitidos
      user.language = language;
    }

    return user;
  } catch (error) {
    consoleError('Error al parsear los datos del usuario');
    store.dispatch('globalModule/setError', 'invalidUser');
    return null;
  }
};

/**
 * Comprueba si los datos de un usuario son válidos
 *
 * @param {Object} userData - Datos del usuario del backend
 * @return {User} - Datos formateados y validados de un usuario
 */
const validateUser = userData => {
  const user = sanitizeUser(userData);

  if (!user || !user.name || !user.lastName || !user.email) {
    store.dispatch('globalModule/setError', 'invalidUser');
    return null;
  }

  return user;
};

export { validateUser, sanitizeUser };
